import {AdditionalProps, DataSource, Stream} from "./dataSourceTypes";
import {DataJob} from "./jobDataTypes";
import {SimpleFileDataSource} from "./generic";

export interface Event {
    id: string;
    name: string;
    description: string;
    start_schedule: string;
    end_schedule: string;
    data_sources: any[];
    type: string;
    home_team: string;
    away_team: string;
    season: string;
    championship: string;
    home_line_up: LineUp;
    away_line_up: LineUp;
    url: string;
    home_score: string;
    away_score: string;
    ready: boolean
    scheduled: boolean;
    streamDataSource: Stream;
    matchday?: number;
    fileDataSource ?: SimpleFileDataSource;
    competition?: Competition;
}

interface Competition {
    id: string;
    name: string;
    type: string;
    season: string;
}

interface LineUp {
    goalkeeper: string[];
    defenders: string[];
    midfielders: string[];
    forwards: string[];
}

export interface EventData {
    idEvent?: string;
    name: string;
    tags: string[];
    description: string;
    event_start: Date,
    event_end: Date,
    championship: string,
    championship_name: string;
    typeEvent: "football";
    dataSource: DataSource[];
    home_team: string;
    away_team: string;
    season: string;
    score?: string;
    half?: string;
    last_event_time?: string;
    last_run?: string;
    jobs?: DataJob[];
    numberClips?: number;
    redCards?: number;
    matchday?: number
    gameNumber?: number;
    venue:string;
    match_type?: string;
    round_type?: string;
    url?: string
}

export interface EventBasketData {
    idEvent?: string;
    name: string;
    tags: string[];
    description: string;
    event_start: Date,
    event_end: Date,
    championship: string,
    championship_name: string;
    typeEvent: "basketball";
    dataSource: DataSource[];
    home_team: string;
    away_team: string;
    season: string;
    matchday?: number;
    "match_type"?: "string",
    "round_type"?: "string",
    "venue": string
    gameNumber?: number;
    external_id: string;

}

export interface MatchDaysEvents {
    matchDay: string;
    events: Event[];
}

export const defaultEvent: EventData = {
    name: '',
    tags: [],
    description: '',
    venue: '',
    away_team: '',
    home_team: '',
    season: '',
    typeEvent: "football",
    event_start: new Date(),
    event_end: new Date(),
    championship: '',
    championship_name: "",
    dataSource: [{
    name: '',
    description: '',
    type: ''
}],
    url: '/atalanta-parma.m3u8'
}

export const defaultBasketEvent: EventBasketData = {
    name: '',
    tags: [],
    description: '',
    venue: '',
    away_team: '',
    home_team: '',
    season: '',
    typeEvent: "basketball",
    event_start: new Date(),
    event_end: new Date(),
    championship: '',
    championship_name: "",
    dataSource: [{
        name: '',
        description: '',
        type: '',
    }],
    matchday: 0,
    gameNumber: 0,
    external_id: '',
}

export interface PlatformEvent {
    id: string;
    name: string;
    description: string;
    type: string;
    data_sources: {
        id: string;
    }[];
    start_schedule: string; // ISO date string
    end_schedule: string; // ISO date string
    tags: string[];
    home_team: string;
    away_team: string;
    competition: Competition;
    matchday: number;
    home_line_up: Record<string, string[]>;
    away_line_up: Record<string, string[]>;
    opta_id: string;
    home_score: number;
    away_score: number;
    round_type: string;
    requested?: boolean;
}

export type AdditionalPropsMap = Record<string, AdditionalProps[]>;

export type GenericEventData = EventData | EventBasketData;